module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Home/Bath-36cacf0a7a2c59ae4b93a516226ce1af.svg";